module.exports = __webpack_public_path__ + "static/media/iconCode.30691464.png";